import type { SvgIconProps } from "@mui/material/SvgIcon";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { CircularProgress } from "@mui/material";
import Button from "@components/common/Button/Button";
import { themeVar } from "@config/theme/cssVar";
import {
	actionIconSx,
	CARD_DELETE_ACTION_BTN_CLASS,
	CARD_EDIT_ACTION_BTN_CLASS,
} from "@config/theme/actionIcons";

export function EditActionIcon({ sx, ...props }: SvgIconProps) {
	return <EditOutlinedIcon {...props} sx={{ ...actionIconSx.edit, ...sx }} />;
}

export function DeleteActionIcon({ sx, ...props }: SvgIconProps) {
	return <DeleteOutlineIcon {...props} sx={{ ...actionIconSx.delete, ...sx }} />;
}

interface CardActionIconButtonProps {
	onClick?: () => void;
	disabled?: boolean;
	loading?: boolean;
	"aria-label"?: string;
}

export function CardEditIconButton({
	onClick,
	disabled,
	"aria-label": ariaLabel = "Edit",
}: CardActionIconButtonProps) {
	return (
		<Button
			variant="icon"
			onClick={onClick}
			disabled={disabled}
			className={CARD_EDIT_ACTION_BTN_CLASS}
			aria-label={ariaLabel}>
			<EditOutlinedIcon fontSize="small" />
		</Button>
	);
}

export function CardViewIconButton({
	onClick,
	disabled,
	"aria-label": ariaLabel = "View details",
}: CardActionIconButtonProps) {
	return (
		<Button
			variant="icon"
			onClick={onClick}
			disabled={disabled}
			className={CARD_EDIT_ACTION_BTN_CLASS}
			aria-label={ariaLabel}>
			<VisibilityOutlinedIcon fontSize="small" />
		</Button>
	);
}

export function CardDeleteIconButton({
	onClick,
	disabled,
	loading = false,
	"aria-label": ariaLabel = "Delete",
}: CardActionIconButtonProps) {
	return (
		<Button
			variant="icon"
			onClick={onClick}
			disabled={disabled}
			className={CARD_DELETE_ACTION_BTN_CLASS}
			aria-label={ariaLabel}>
			{loading ? (
				<CircularProgress size={16} sx={{ color: "var(--admin-danger)" }} />
			) : (
				<DeleteOutlineIcon fontSize="small" sx={{ color: themeVar.danger }} />
			)}
		</Button>
	);
}
